import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/icons/arrows/arr-orange-down.svg';
import _imports_1 from '@/assets/icons/actions/ico-ico-label.svg';
import _imports_2 from '@/assets/icons/actions/ico-ico-zmenarezimu.svg';
import _imports_3 from '@/assets/icons/actions/ico-ico-zmenaskupiny.svg';
import _imports_4 from '@/assets/icons/actions/ico-ico-delete-l.svg';
import _imports_5 from '@/assets/icons/icon_xlsx.svg';
import _imports_6 from '@/assets/icons/icon_csv.svg';
import _imports_7 from '@/assets/icons/actions/ico-ico-upravitzarizeni.svg';
const _hoisted_1 = { class: "list-page" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "layout__content__header d-flex flex-column list-page__header layout__content__header--white" };
const _hoisted_4 = { class: "d-flex flex-wrap mb-4 mb-sm-0 justify-content-between" };
const _hoisted_5 = { class: "mb-1 mb-sm-4" };
const _hoisted_6 = { class: "d-flex justify-content-between" };
const _hoisted_7 = {
    class: "list-page__link d-flex d-lg-none mt-md-2 justify-content-start",
    style: { "flex-shrink": "0" }
};
const _hoisted_8 = { class: "layout__content__header layout__content__header--white pt-0 pb-0" };
const _hoisted_9 = {
    key: 0,
    class: "detail-page__tabs__header d-flex"
};
const _hoisted_10 = { class: "d-flex align-items-end detail-page__tabs__wrapper mt-5" };
const _hoisted_11 = {
    key: 1,
    class: "layout__content__content pt-4 pt-md-5"
};
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "row" };
const _hoisted_14 = { class: "row" };
const _hoisted_15 = { style: { "display": "block", "word-wrap": "break-word" } };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = {
    key: 0,
    class: "atom-expand"
};
const _hoisted_18 = { key: 0 };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
    key: 2,
    class: "layout__content__content pt-4 pt-md-5"
};
const _hoisted_22 = {
    key: 3,
    class: "layout__content__content pt-4 pt-md-5"
};
const _hoisted_23 = { key: 1 };
const _hoisted_24 = { class: "layout__content__header list-page__header" };
const _hoisted_25 = { class: "mb-4 mb-sm-0 justify-content-between" };
const _hoisted_26 = { class: "mb-1 mb-sm-4" };
const _hoisted_27 = { key: 0 };
const _hoisted_28 = { class: "box-danger font-weight-bold" };
import { useStore } from "vuex";
import { computed, onMounted, ref, watch } from "vue";
import { useUdpStore } from "@/store/modules/devices/udp";
import Loader from "@/components/loader.vue";
import DeviceSearch from "@/components/devices/partials/DeviceSearch.vue";
import RadioHelp from "@/components/radio/radio-help.vue";
import RadioOpenClose from "@/components/radio/radio-open-close.vue";
import DeviceStatusIcon from "@/components/devices/partials/DeviceStatusIcon.vue";
import TagBubbles from "@/components/devices/tagBubbles.vue";
import { useRoute } from "vue-router";
import TableV2 from "@/components/custom-table/TableV2.vue";
import ImportDeviceButton from "@/components/devices/partials/ImportDeviceButton.vue";
import UdpDeviceFormModal from "@/components/devices/udp/UdpDeviceFormModal.vue";
import Delete from "@/components/confirmations/delete.vue";
import { client } from "@/main";
import ErrorModal from "@/components/confirmations/translatedErrors.vue";
import Dropdown from "@/components/common/Dropdown.vue";
import AddTagsModal from "@/components/modals/devices/addTags.vue";
import RemoveTagsModal from "@/components/modals/devices/removeTags.vue";
import AddToGroupsModal from "@/components/modals/devices/addToGroups.vue";
import ChangeStatusModal from "@/components/modals/devices/changeStatus.vue";
import { useI18n } from "vue-i18n";
import { exportDevices } from "@/plugins/exportDevices";
import { useProjectStore } from "@/store/modules/project";
import { useConfigStore } from "@/store/modules/config";
export default /*@__PURE__*/ _defineComponent({
    __name: 'udp',
    setup(__props) {
        onMounted(() => {
            loadDevices();
            loadServices();
        });
        const store = useStore();
        const route = useRoute();
        const { t: $t } = useI18n();
        const projectStore = useProjectStore();
        const configStore = useConfigStore();
        const udpStore = useUdpStore();
        const project = computed(() => projectStore.selectedProject);
        const copyConfirmVisible = ref(false);
        const search = ref("");
        const isSearchThroughAllProjects = ref(false);
        const sort = ref("name");
        const sortType = ref("asc");
        const rowsPerPage = ref(10);
        const page = ref(0);
        const deviceList = computed(() => udpStore.deviceList);
        const selectedRows = ref([]);
        const openedTags = ref([]);
        const isLoading = ref(false);
        const isExtendedSearchOpen = ref(false);
        const paramFilterData = ref([]);
        const editedDevice = ref(null);
        const isEditOpen = ref(false);
        const isDeleteOpen = ref(false);
        const isAddToGroupsOpen = ref(false);
        const isAddTagsModalOpen = ref(false);
        const isRemoveTagsModalOpen = ref(false);
        const isChangeStatusModlaOpen = ref(false);
        const errors = ref([]);
        const isErrorModalOpen = ref(false);
        async function loadDevices() {
            isLoading.value = true;
            if (route.params.notifications?.[0]?.text) {
                store.commit("modals/setGlobalNotification", route.params.notifications);
            }
            const filterData = [];
            if (!isSearchThroughAllProjects.value) {
                filterData.push({
                    field: "projectId",
                    value: route.params.projectId
                });
            }
            for (const param of paramFilterData.value) {
                filterData.push({
                    field: param.name,
                    value: param.value,
                    operator: param.operator
                });
            }
            await udpStore.getList({
                filters: filterData,
                search: search.value,
                sort: sort.value,
                sortType: sortType.value,
                rowsPerPage: rowsPerPage.value,
                currentPage: page.value
            });
            isLoading.value = false;
        }
        async function loadServices() {
            await store.dispatch("services/getServices");
        }
        const isUdpServiceAvailable = computed(() => {
            return (store.state.services.services.length &&
                store.state.services.services?.some((s) => s.enabled && !s.suspended && s.productElementId === "s_iot2293"));
        });
        function setFilterData(filterData) {
            if (filterData.length) {
                paramFilterData.value = filterData;
            }
            else {
                paramFilterData.value = [];
            }
            page.value = 0;
            loadDevices();
        }
        const radioSlides = ref([]);
        const showRadioHelp = ref(!configStore.isRadioHelpDisabled);
        watch(() => configStore.isRadioHelpDisabled, (value) => {
            showRadioHelp.value = !value;
        });
        watch(() => [page.value, sort.value, sortType.value], () => {
            loadDevices();
        });
        watch(() => rowsPerPage.value, () => {
            if (!page.value) {
                loadDevices();
            }
        });
        const tableColumns = [
            {
                name: "name",
                title: "custDeviceName",
                sortable: true,
                sortBy: "name",
                visible: true,
                minWidth: "300px",
                order: 1
            },
            {
                name: "status",
                sortable: true,
                sortBy: "status",
                visible: true,
                minWidth: "60px",
                order: 1
            },
            {
                name: "deviceId",
                title: "idZarizeniMQTT",
                sortable: true,
                sortBy: "deviceId",
                visible: true,
                order: 1
            },
            {
                name: "deviceGroups",
                sortable: false,
                visible: true,
                order: 1
            },
            {
                name: "tags",
                sortable: false,
                visible: true,
                order: 1
            },
            {
                name: "lastMessageIn",
                sortable: true,
                sortBy: "lastMessageIn",
                visible: true,
                order: 1
            }
        ];
        const filterType = [
            {
                name: "DEVICE_NAME",
                type: "name",
                arrayValue: []
            },
            {
                name: "DEVICE_STATUS_IS",
                type: "status",
                arrayValue: []
            },
            {
                name: "IS_IN_GROUPS",
                type: "deviceGroupId",
                arrayValue: []
            },
            {
                name: "HAS_TAGS",
                type: "tags",
                arrayValue: []
            },
            {
                name: "SERVICE_IS",
                type: "custServiceId",
                arrayValue: []
            },
            {
                name: "deviceId",
                type: "deviceId",
                arrayValue: []
            },
            {
                name: "LAST_MESSAGE_IN",
                type: "lastMessageIn",
                arrayValue: []
            }
        ];
        async function deleteDevices() {
            store.commit("modals/setWaitingLoader", $t("Ukládám data, čekejte prosím..."));
            const notifications = [];
            const erItem = { errors: [] };
            for (const device of editedDevice.value ? [editedDevice.value] : selectedRows.value) {
                try {
                    await deleteDevice(device);
                }
                catch (e) {
                    const message = e?.data?.errors?.[0];
                    erItem.errors.push({
                        message: message,
                        attribute: {
                            deviceId: device.deviceId,
                            custDeviceName: device.name
                        }
                    });
                }
                finally {
                    notifications.push({
                        text: "notificationDeviceDelete",
                        error: true,
                        params: {
                            deviceId: device.deviceId,
                            custDeviceName: device.name
                        }
                    });
                }
            }
            if (erItem.errors.length) {
                errors.value = [erItem];
            }
            store.commit("modals/setWaitingLoader", "");
            store.commit("modals/setGlobalNotification", notifications);
            editedDevice.value = null;
            isDeleteOpen.value = false;
            loadDevices();
        }
        async function deleteDevice(device) {
            for (const group of device.deviceGroups ?? []) {
                if (!group.deviceGroupId)
                    continue;
                await client.path("/device-groups/{id}/devices/{protocol}/{deviceId}/assign").method("delete").create()({
                    deviceId: device.deviceId ?? "",
                    id: group.deviceGroupId.toString(),
                    protocol: "udp"
                });
            }
            await client.path("/udp/devices/{id}").method("delete").create()({ id: device.deviceId ?? "" });
        }
        async function handleExportDevices(format) {
            errors.value = [];
            store.commit("modals/setWaitingLoader", $t("Exportuji data, čekejte prosím..."));
            const exportErrors = await exportDevices(format, "udp", project.value?.projectId ?? "", selectedRows.value.map((device) => device.deviceId ?? ""));
            store.commit("modals/setWaitingLoader", "");
            if (exportErrors?.length) {
                errors.value = exportErrors;
                isErrorModalOpen.value = true;
            }
        }
        return (_ctx, _cache) => {
            const _component_Notify = _resolveComponent("Notify");
            const _component_RouterLink = _resolveComponent("RouterLink");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (project.value && project.value.projectId != 'undefined' && isUdpServiceAvailable.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_Notify, {
                                opened: copyConfirmVisible.value,
                                text: 'zkopirovanoDoSchranky',
                                onClose: _cache[0] || (_cache[0] = ($event) => (copyConfirmVisible.value = false))
                            }, null, 8, ["opened"]),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref($t)("UDP_ZARIZENI")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(DeviceSearch, {
                                    "filter-type": filterType,
                                    "project-id": project.value.projectId ?? '',
                                    "reload-items": loadDevices,
                                    "update-responsive-table": () => { },
                                    technology: "udp",
                                    onSearch: _cache[1] || (_cache[1] = ($event) => (search.value = $event)),
                                    onAllProjects: _cache[2] || (_cache[2] = ($event) => (isSearchThroughAllProjects.value = $event)),
                                    onSetFilterData: setFilterData
                                }, null, 8, ["project-id"]),
                                _createVNode(ImportDeviceButton)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("a", {
                                    class: _normalizeClass([{ open: isExtendedSearchOpen.value }, "d-flex align-items-center extended-search__toggle"]),
                                    onClick: _cache[3] || (_cache[3] = ($event) => (isExtendedSearchOpen.value = !isExtendedSearchOpen.value))
                                }, [
                                    _createTextVNode(_toDisplayString(_unref($t)("pokrocilaFiltrace")) + " ", 1),
                                    _cache[25] || (_cache[25] = _createElementVNode("img", {
                                        class: "",
                                        src: _imports_0
                                    }, null, -1))
                                ], 2)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(RadioHelp, {
                                "article-link": '/devices/udp',
                                show: showRadioHelp.value,
                                onChangeRadioBtnVisibility: _cache[4] || (_cache[4] = ($event) => (radioSlides.value = $event)),
                                onUpdateShowRadioHelp: _cache[5] || (_cache[5] = ($event) => (showRadioHelp.value = $event))
                            }, null, 8, ["show"])
                        ]),
                        (radioSlides.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createVNode(RadioOpenClose, {
                                        "radio-slides": radioSlides.value,
                                        show: showRadioHelp.value,
                                        onUpdateShowRadioHelp: _cache[6] || (_cache[6] = ($event) => (showRadioHelp.value = $event))
                                    }, null, 8, ["radio-slides", "show"])
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (deviceList.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(Dropdown, {
                                    title: _unref($t)('hromadneAkce'),
                                    disabled: !selectedRows.value.length
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("div", {
                                                class: "dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12",
                                                onClick: _cache[7] || (_cache[7] =
                                                    () => {
                                                        isAddTagsModalOpen.value = true;
                                                    })
                                            }, [
                                                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "atom-icon" }, [
                                                    _createElementVNode("img", { src: _imports_1 })
                                                ], -1)),
                                                _createTextVNode(" " + _toDisplayString(_unref($t)("pridatTagy")), 1)
                                            ]),
                                            _createElementVNode("div", {
                                                class: "dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12",
                                                onClick: _cache[8] || (_cache[8] =
                                                    () => {
                                                        isChangeStatusModlaOpen.value = true;
                                                    })
                                            }, [
                                                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "atom-icon" }, [
                                                    _createElementVNode("img", { src: _imports_2 })
                                                ], -1)),
                                                _createTextVNode(" " + _toDisplayString(_unref($t)("zmenitRezim")), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("div", {
                                                class: "dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12",
                                                onClick: _cache[9] || (_cache[9] =
                                                    () => {
                                                        isRemoveTagsModalOpen.value = true;
                                                    })
                                            }, [
                                                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "atom-icon" }, [
                                                    _createElementVNode("img", { src: _imports_1 })
                                                ], -1)),
                                                _createTextVNode(" " + _toDisplayString(_unref($t)("odebratTagy")), 1)
                                            ]),
                                            _createElementVNode("div", {
                                                class: "dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12",
                                                onClick: _cache[10] || (_cache[10] =
                                                    () => {
                                                        isAddToGroupsOpen.value = true;
                                                    })
                                            }, [
                                                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "atom-icon" }, [
                                                    _createElementVNode("img", { src: _imports_3 })
                                                ], -1)),
                                                _createTextVNode(" " + _toDisplayString(_unref($t)("CHANGE_DATA_FLOW")), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("div", {
                                                class: "dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12",
                                                onClick: _cache[11] || (_cache[11] =
                                                    () => {
                                                        isDeleteOpen.value = true;
                                                    })
                                            }, [
                                                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "atom-icon" }, [
                                                    _createElementVNode("img", { src: _imports_4 })
                                                ], -1)),
                                                _createTextVNode(" " + _toDisplayString(_unref($t)("smazatZarizeni")), 1)
                                            ]),
                                            _createElementVNode("div", {
                                                class: "dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12",
                                                onClick: _cache[12] || (_cache[12] = ($event) => (handleExportDevices('xlsx')))
                                            }, [
                                                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "atom-icon" }, [
                                                    _createElementVNode("img", { src: _imports_5 })
                                                ], -1)),
                                                _createTextVNode(" " + _toDisplayString(_unref($t)("LABEL_EXPORT_XLSX")), 1)
                                            ]),
                                            _createElementVNode("div", {
                                                class: "dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12",
                                                onClick: _cache[13] || (_cache[13] = ($event) => (handleExportDevices('csv')))
                                            }, [
                                                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "atom-icon" }, [
                                                    _createElementVNode("img", { src: _imports_6 })
                                                ], -1)),
                                                _createTextVNode(" " + _toDisplayString(_unref($t)("LABEL_EXPORT_CSV")), 1)
                                            ])
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["title", "disabled"]),
                                _createVNode(TableV2, {
                                    columns: tableColumns,
                                    items: deviceList.value,
                                    "items-total-count": _unref(udpStore).totalCount,
                                    "item-id": "deviceId",
                                    "table-id": "udp",
                                    kebab: "",
                                    selectable: "",
                                    onRowsSelected: _cache[14] || (_cache[14] = ($event) => (selectedRows.value = $event)),
                                    onPageChange: _cache[15] || (_cache[15] = ($event) => (page.value = $event)),
                                    onPageSizeChange: _cache[16] || (_cache[16] = ($event) => (rowsPerPage.value = $event)),
                                    onSortBy: _cache[17] || (_cache[17] =
                                        (e) => {
                                            sort.value = e.sortBy;
                                            sortType.value = e.sortType;
                                        })
                                }, {
                                    status: _withCtx(({ item }) => [
                                        _createVNode(DeviceStatusIcon, { device: item }, null, 8, ["device"])
                                    ]),
                                    name: _withCtx(({ item }) => [
                                        _createVNode(_component_RouterLink, {
                                            to: {
                                                name: 'udpDevice',
                                                params: {
                                                    id: item.deviceId,
                                                    device: item,
                                                    customerId: item.customerId,
                                                    projectId: item.projectId
                                                }
                                            },
                                            class: "font-weight-bolder link-gray"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_15, _toDisplayString(item.name), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["to"])
                                    ]),
                                    deviceGroups: _withCtx(({ item }) => [
                                        (!item.deviceGroups.length)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                                            : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.deviceGroups.slice(0, 1), (group) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: group.deviceGroupId + 'g' + item.deviceId,
                                                class: "d-flex"
                                            }, [
                                                _createVNode(_component_RouterLink, {
                                                    class: "link-gray",
                                                    to: {
                                                        name: 'group',
                                                        params: {
                                                            id: group.deviceGroupId,
                                                            projectId: group.projectId,
                                                            customerId: _unref(route).params.customerId
                                                        }
                                                    }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.strLimit(group.deviceGroupName, 25)), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["to"]),
                                                (item.deviceGroups.length > 1)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(item.deviceGroups.length - 1), 1))
                                                    : _createCommentVNode("", true)
                                            ]));
                                        }), 128))
                                    ]),
                                    tags: _withCtx(({ item }) => [
                                        _createVNode(TagBubbles, {
                                            "is-open": openedTags.value.includes(item),
                                            "tag-list": item.tags
                                        }, null, 8, ["is-open", "tag-list"])
                                    ]),
                                    lastMessageIn: _withCtx(({ item }) => [
                                        (item.lastMessageIn != null)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref($t)("pred")) + " " + _toDisplayString(_ctx.$filters.beforeTime(item.lastMessageIn, "short")), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    "kebab-actions": _withCtx(({ item }) => [
                                        _createElementVNode("div", {
                                            class: "dropdown-actions__item d-flex align-items-center",
                                            onClick: () => {
                                                editedDevice.value = item;
                                                isEditOpen.value = true;
                                            }
                                        }, [
                                            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "atom-icon" }, [
                                                _createElementVNode("img", { src: _imports_7 })
                                            ], -1)),
                                            _createTextVNode(" " + _toDisplayString(_unref($t)("upravitZarizeni")), 1)
                                        ], 8, _hoisted_19),
                                        _createElementVNode("div", {
                                            class: "dropdown-actions__item d-flex align-items-center",
                                            onClick: () => {
                                                editedDevice.value = item;
                                                isDeleteOpen.value = true;
                                            }
                                        }, [
                                            _cache[34] || (_cache[34] = _createElementVNode("div", { class: "atom-icon" }, [
                                                _createElementVNode("img", { src: _imports_4 })
                                            ], -1)),
                                            _createTextVNode(" " + _toDisplayString(_unref($t)("odstranitZarizeni")), 1)
                                        ], 8, _hoisted_20)
                                    ]),
                                    _: 1
                                }, 8, ["items", "items-total-count"])
                            ]))
                            : (!isLoading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref($t)("nicKZobrazeni")) + ".", 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createVNode(Loader)
                                ]))
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("h1", _hoisted_26, _toDisplayString(_unref($t)("UDP_ZARIZENI")), 1),
                                (!isUdpServiceAvailable.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createElementVNode("div", _hoisted_28, _toDisplayString(_unref($t)("NO_UDP_SERVICE")), 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])),
                (editedDevice.value)
                    ? (_openBlock(), _createBlock(UdpDeviceFormModal, {
                        key: 2,
                        "edited-device": editedDevice.value,
                        "is-opened": isEditOpen.value,
                        onChange: loadDevices,
                        onClose: _cache[18] || (_cache[18] =
                            () => {
                                isEditOpen.value = false;
                                editedDevice.value = null;
                            })
                    }, null, 8, ["edited-device", "is-opened"]))
                    : _createCommentVNode("", true),
                _createVNode(Delete, {
                    opened: isDeleteOpen.value,
                    items: editedDevice.value ? [editedDevice.value] : selectedRows.value,
                    text: editedDevice.value ? editedDevice.value.name : selectedRows.value.length > 1 ? 'zarizeniPocet' : selectedRows.value[0]?.name,
                    centered: "",
                    onClose: _cache[19] || (_cache[19] =
                        () => {
                            isDeleteOpen.value = false;
                            editedDevice.value = null;
                        }),
                    onYes: deleteDevices
                }, null, 8, ["opened", "items", "text"]),
                (errors.value.length)
                    ? (_openBlock(), _createBlock(ErrorModal, {
                        key: 3,
                        centered: "",
                        errors: errors.value,
                        opened: isErrorModalOpen.value,
                        onClose: _cache[20] || (_cache[20] = ($event) => (isErrorModalOpen.value = false))
                    }, null, 8, ["errors", "opened"]))
                    : _createCommentVNode("", true),
                _createVNode(AddToGroupsModal, {
                    devices: selectedRows.value,
                    opened: isAddToGroupsOpen.value ? ['addToGroups'] : [],
                    technology: "udp",
                    onCloseBox: _cache[21] || (_cache[21] = ($event) => (isAddToGroupsOpen.value = false)),
                    onReloadItems: loadDevices
                }, null, 8, ["devices", "opened"]),
                _createVNode(AddTagsModal, {
                    devices: selectedRows.value,
                    opened: isAddTagsModalOpen.value ? ['editTags'] : [],
                    technology: "udp",
                    onCloseBox: _cache[22] || (_cache[22] = ($event) => (isAddTagsModalOpen.value = false))
                }, null, 8, ["devices", "opened"]),
                _createVNode(RemoveTagsModal, {
                    devices: selectedRows.value,
                    opened: isRemoveTagsModalOpen.value ? ['editTags'] : [],
                    technology: "udp",
                    onCloseBox: _cache[23] || (_cache[23] = ($event) => (isRemoveTagsModalOpen.value = false))
                }, null, 8, ["devices", "opened"]),
                _createVNode(ChangeStatusModal, {
                    devices: selectedRows.value,
                    opened: isChangeStatusModlaOpen.value ? ['changeStatus'] : [],
                    technology: "udp",
                    onCloseBox: _cache[24] || (_cache[24] = ($event) => (isChangeStatusModlaOpen.value = false))
                }, null, 8, ["devices", "opened"])
            ]));
        };
    }
});
